import { Component } from '@angular/core';
import { VonPageResponseModel } from '@von-development-studio/angular-rest-service';
import { LazyLoadEvent, MenuItem } from 'primeng/api';
import { BaseComponent } from 'src/app/core/base/base.component';
import { CommonPersonViewModel } from 'src/app/model/common/person.view';
import { PERSON } from '../person.constants';
import { PersonService } from '../person.service';
import { PersonDialogComponent } from './person-dialog.component';

@Component({
  selector: 'ms-common-person',
  templateUrl: './person-main.component.html',
})
export class PersonMainComponent extends BaseComponent {
  readonly screen = PERSON;
  protected setScreen = true;
  people: VonPageResponseModel<CommonPersonViewModel> =
    {} as VonPageResponseModel<CommonPersonViewModel>;
  selectedPerson: CommonPersonViewModel = {};
  options: MenuItem[] = [];
  dtDocumentFilter?: string;
  dtNameFilter?: string;

  constructor(protected service: PersonService) {
    super();
  }

  onInit = () => {
    this.loading = true;
    this.subscriptions.push(
      this.service
        .readPersonLazyLoad()
        .subscribe((response) => (this.people = response))
    );
    this.setDefaultContextMenu();
  };

  openModal = (isNew: boolean = true) =>
    this.service.openPersonDialog(isNew, PersonDialogComponent);

  lazyReadPeople = ($event: LazyLoadEvent) => {
    this.service.setLoadingState();
    const page = $event.first! / $event.rows!;
    this.subscriptions.push(
      this.service
        .getPeople(
          page,
          $event.rows!,
          $event.filters!.fullName,
          $event.filters!.document
        )
        .subscribe()
    );
  };

  setContextMenuItems = () => {
    const idx = this.options.findIndex((op) => op.id === 'enableDisable');
    this.options[idx] = {
      ...this.options[idx],
      label:
        this.screen.actions[this.selectedPerson.status ? 'disable' : 'enable'],
      styleClass: `text-${this.selectedPerson.status ? 'danger' : 'success'}`,
      icon: `far ${
        this.selectedPerson.status ? 'fa-trash-alt' : 'fa-check-circle'
      }`,
    };
  };

  private setDefaultContextMenu = () => {
    this.options.push({
      id: 'edit',
      label: this.screen.actions.edit,
      styleClass: 'text-warning',
      icon: 'fas fa-pencil-alt',
      command: (_) =>
        this.subscriptions.push(
          this.service
            .getPersonById(this.selectedPerson.id!)
            .subscribe(() => this.openModal(false))
        ),
    });
    this.options.push({
      id: 'enableDisable',
      label: this.screen.actions.disable,
      styleClass: 'text-danger',
      icon: 'far fa-trash-alt',
      command: (_) =>
        this.service.changeStatus(this.selectedPerson.id!).subscribe(),
    });
  };
}
